import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { navigate("/login"); return; }
    (async () => {
      try {
        await http.post("/auth/session", { session_id: sid });
        window.history.replaceState({}, document.title, "/home");
        await refresh();
        toast.success("Signed in with Google. Court is yours.");
        navigate("/home", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed.");
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center pv-bg-neutral">
      <div className="text-center">
        <Loader2 className="mx-auto animate-spin pv-text-dark" size={32}/>
        <p className="mt-3 text-sm text-gray-600">Warming up the paddle grip…</p>
      </div>
    </div>
  );
}
